"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.upgrade.errors.loadGrades': 'Failed to load price packages',
    'account.upgrade.loadingGrades': 'Loading price packages...',
    'account.upgrade.title': 'Account Upgrade',
    'account.upgrade.currentGrade': 'Current Price Package',
    'account.upgrade.selectGrade': 'Your plan',
    'account.upgrade.save': 'Save Changes',
    'account.upgrade.payNow': 'Pay Now & Upgrade',
    'account.upgrade.downgrade': 'Switch to Lower Plan',
    'account.upgrade.mostPopular': 'Most Popular',
    'account.upgrade.selectPlan': 'Select Plan',
    'account.upgrade.selected': 'Selected',
    'account.upgrade.success': 'Price package updated successfully',
    'account.upgrade.paymentInitiated': 'Payment initiated. Please complete payment to upgrade your account.',
    'account.upgrade.errors.general': 'Failed to update price package',
    'account.upgrade.errors.loadUser': 'Failed to load user information',
    'account.upgrade.errors.noUser': 'User not found',
    'account.upgrade.credits': 'credits',
    'account.upgrade.noCredits': 'No credits included',
    'account.upgrade.perMonth': 'per month',
    'account.upgrade.changePlan': 'Change Plan',
    'account.upgrade.currentPlan': 'Current Plan',
    'account.upgrade.futureGradeInfo': 'This plan will be activated on',
    'account.upgrade.confirm.title': 'Confirm Plan Change',
    'account.upgrade.confirm.downgrade': 'Are you sure you want to downgrade to the free plan? You will lose access to premium features.',
    'account.upgrade.confirm.change': 'Are you sure you want to change your plan to',
    'account.upgrade.success.changed': 'Your plan has been successfully changed',
    'account.upgrade.success.upgraded': 'Account successfully upgraded!',
    'account.upgrade.errors.changeFailed': 'Failed to change your plan',
    'account.upgrade.errors.paymentFailed': 'Payment failed. Please try again.',
    'account.upgrade.monthly': 'Monthly',
    'account.upgrade.yearly': 'Yearly',
    'account.upgrade.saveMore': 'Save More',
    'account.upgrade.discount': 'OFF',
    'account.upgrade.save_money_amount': 'Save',
};
